module.exports = __webpack_public_path__ + "static/media/screenshotpage2.c5d27a43.png";